import type { Meta, StoryFn } from '@storybook/react';
import type { InputProps } from './Input';

import { Input } from './Input';

const codeString = `
// Has all HTMLInputElement props available except "className" and "style" 
<Input id={id} type={type} aria-label={aria-label} onChange={onChangeFunction} value={value}/>
`;

// eslint-disable-next-line import/no-default-export
export default {
  title: 'Atoms/Input',
  component: Input,
  argTypes: {
    appearance: {
      table: {
        disable: true,
      },
    },
    type: {
      control: 'inline-radio',
    },
  },
  args: {
    id: '30daa7c7',
    type: 'text',
    disabled: false,
    placeholder: '',
  },
  parameters: {
    inspectComponent: Input,
    codeString: codeString,
  },
} as Meta<InputProps>;

const Template: StoryFn<InputProps> = (args) => {
  return <Input {...args} />;
};

export const InputExample = Template.bind({});
InputExample.args = {};

export const FullWidth = Template.bind({});
FullWidth.args = {
  fullWidth: true,
};

export const Numeric = Template.bind({});
Numeric.args = {
  isNumeric: true,
};

export const WithErrorAppearance = Template.bind({});
WithErrorAppearance.args = {
  appearance: 'error',
};
